const color = {
  color1: '#fff',
  color2: '#000',
  color3: '#f7f5f5',
  color4: '#E4E7FE',
  color5: '#F7F7F4',
  color6: 'rgba(55,55,55,0.5)',
  color7: 'rgba(255, 255, 255, 1)',
  color8: 'blue',
  color9: 'red',
  color10: '#3b44f5',
  color11: 'green',
  color12: '#1256a9',
  color13: '#aaa',
  color14: '#e3ebff',
  color15: '#eee',
  color16: 'rgba(249, 189, 255, 0.3)',
  color17: 'rgba(0,0,0,0)',
  color18: '#c2d9fc',
  color19: '#c90bd6',
  color20: '#ff5024',
  color21: '#87A9FF',
  color22: '#7B7DE8',
  color23: 'navy',
  color24: '#555',
  color25: '#dbe2ff',
  color26: '#e2c9ff',
  color27: 'yellow',
  color28: '#777',
  color29: '#de5959',
  color30: '#d1d7ff',
  color31: '#ddd',
  color32: '#6577f0',
  color33: '#f4f0f9',
  color34: 'cyan',
  color35: 'gray',
  color36: 'rgba(0,0,0,0.3)',
  color37: 'rgba(0,0,0,0.5)',
  color38: '#11DD11',
  color39: 'rgba(2,2,2,0.2)',
  color40: 'rgba(194, 217, 252, 0.3)',
  color41: '#FF7059',
  color42: '#E85156',
  color43: '#FF67B7',
  color44: '#E551E8',
  color45: '#CF59FF',
  color46: '#A654FF',
  color47: '#6C4DE8',
  color48: '#616BFF',
  color49: '#4D80E8',
  color50: '#54B9FF',
  color51: 'rgb(255, 87, 90)',
  color52: 'rgb(230, 212, 254)',
  color53: '#6200a8',
  color54: 'rgba(255, 230, 230, 1)',
  color55: 'rgb(255, 142, 148)',
  color56: 'rgb(175, 174, 214)',
  color57: 'rgb(26, 24, 97)',
  color58: 'rgb(228, 228, 228)',
  color59: 'transparent',
  color60: 'rgb(247, 123, 121)',
  color61: 'rgb(74, 49, 79)',
  color62: 'rgb(77, 66, 96)',
  color63: 'rgb(50, 1, 83)',
  color64: 'rgb(94, 224, 150)',
  color65: 'rgb(255, 238, 238)',
  color66: 'rgb(243, 230, 255)',
  color67: 'rgb(254, 225, 247)',
  color68: 'rgb(218, 255, 237)',
  color69: 'rgb(227, 227, 255)',
  color70: 'rgb(95, 93, 238)',
  color71: 'rgb(145, 90, 233)',
  color72: 'rgb(98, 224, 150)',
  color73: 'rgb(244, 95, 13)',
  color74: 'rgb(245, 96,  212)',

  firstColor: '#35284A',
  secondColor: '#FB7D79',
  thirdColor: '#E6E1F4',
  fourthColor: '#F5F2F9',
  fifthColor: '#FFFFFF',
  sixColor: '#000000',

  fisrtColorOpacity: opacity => {
    return 'rgba(53, 40, 74,' + opacity + ')';
  },
  secondColorOpacity: opacity => {
    return 'rgba(251, 125, 121,' + opacity + ')';
  },
  thirdColorOpacity: opacity => {
    return 'rgba(230, 225, 244,' + opacity + ')';
  },
  fourthColorOpacity: opacity => {
    return 'rgba(245, 242, 249,' + opacity + ')';
  },
  fifthColorOpacity: opacity => {
    return 'rgba(255, 255, 255,' + opacity + ')';
  },
  sixthColorOpacity: opacity => {
    return 'rgba(0, 0, 0,' + opacity + ')';
  },

};

export default color
